import {
  IconArrowLeft,
  IconChartDots,
  IconChecks,
  IconCirclePlus,
  IconCreditCard,
  IconHeadset,
  IconHome2,
  IconListDetails,
  IconLogin2,
  IconLock,
  IconMail,
  IconReceipt2,
  IconSearch,
  IconShieldLock,
  IconShieldCheck,
  IconUserCircle,
  IconUserPlus,
  IconUsers,
  IconWallet,
} from "@tabler/icons-react"

export const APP_ICON_SIZES = {
  inline: 16,
  nav: 18,
  page: 20,
}

export const APP_ICON_STROKE = 1.75

export function appIconProps(size = "nav") {
  return {
    size: APP_ICON_SIZES[size] || APP_ICON_SIZES.nav,
    stroke: APP_ICON_STROKE,
    color: "currentColor",
  }
}

export function appIcon(Icon, size = "nav", props = {}) {
  return <Icon {...appIconProps(size)} {...props} />
}

export {
  IconArrowLeft,
  IconChartDots,
  IconChecks,
  IconCirclePlus,
  IconCreditCard,
  IconHeadset,
  IconHome2,
  IconListDetails,
  IconLogin2,
  IconLock,
  IconMail,
  IconReceipt2,
  IconSearch,
  IconShieldLock,
  IconShieldCheck,
  IconUserCircle,
  IconUserPlus,
  IconUsers,
  IconWallet,
}
